import { useState, useEffect } from 'react'

/**
 * Hooks deboucing a value
 * @param {string} value value to be debounce
 * @param {string} delay delay for firing debounce
 */
const useDebounce = (value: any, delay: any) => {
    const [debouncedValue, setDebouncedValue] = useState(value)

    useEffect(() => {
        // Update debounced value after delay
        const handler = setTimeout(() => {
            setDebouncedValue(value)
        }, delay)

        return () => {
            clearTimeout(handler)
        }
    }, [value, delay])

    return debouncedValue
}

export default useDebounce
